import { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "@/App";
import { loginWithGoogle } from "@/lib/api";
import { Crown, Phone, Globe, User } from "lucide-react";

export default function Header() {
  const { lang, setLang, user, t } = useContext(AppContext);
  return (
    <header className="glass-nav fixed top-0 z-50 w-full border-b border-[rgba(212,175,55,0.15)]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <a href="#top" data-testid="nav-logo-brand" className="flex items-center gap-2">
          <Crown className="h-6 w-6 text-[#D4AF37]" />
          <span className="font-display text-lg font-semibold tracking-wide text-white">
            R.P. <span className="text-[#D4AF37]">Limousine</span> Milano
          </span>
        </a>
        <nav className="hidden items-center gap-6 text-sm text-neutral-300 lg:flex">
          <a href="#servizi" className="transition-colors hover:text-[#E5C158]">{t.nav.services}</a>
          <a href="#flotta" className="transition-colors hover:text-[#E5C158]">{t.nav.fleet}</a>
          <a href="#tariffe" className="transition-colors hover:text-[#E5C158]">{t.nav.rates}</a>
          <a href="#contatti" className="transition-colors hover:text-[#E5C158]">{t.nav.contact}</a>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <button
            data-testid="language-toggle-btn"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
            className="flex items-center gap-1.5 rounded-full border border-[rgba(212,175,55,0.3)] px-3 py-1.5 font-code text-xs uppercase tracking-widest text-[#E5C158] transition-colors hover:border-[#D4AF37]"
          >
            <Globe className="h-3.5 w-3.5" />
            {lang === "it" ? "EN" : "IT"}
          </button>
          {user ? (
            <Link
              to="/account"
              data-testid="user-login-google-btn"
              className="flex items-center gap-2 rounded-full border border-[rgba(212,175,55,0.3)] px-3 py-1.5 text-xs text-neutral-200 transition-colors hover:border-[#D4AF37]"
            >
              {user.picture ? (
                <img src={user.picture} alt="" className="h-5 w-5 rounded-full" />
              ) : (
                <User className="h-4 w-4 text-[#D4AF37]" />
              )}
              <span className="hidden sm:inline">{user.name?.split(" ")[0]}</span>
            </Link>
          ) : (
            <button
              data-testid="user-login-google-btn"
              onClick={loginWithGoogle}
              className="hidden items-center gap-2 rounded-full border border-[rgba(212,175,55,0.3)] px-3 py-1.5 text-xs text-neutral-200 transition-colors hover:border-[#D4AF37] sm:flex"
            >
              <User className="h-4 w-4 text-[#D4AF37]" />
              {t.nav.login}
            </button>
          )}
          <a href="tel:+393482215105" data-testid="phone-quick-call-btn" className="btn-gold !px-4 !py-1.5 !text-xs">
            <Phone className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{t.nav.call}</span>
          </a>
        </div>
      </div>
    </header>
  );
}
